import {
  FETCH_DOMESTICO_INFO,
  SEND_DOMESTICO,
  EDIT_DOMESTICO,
} from './actions.type';

import {
  SET_ERROR,
  FETCHING_DOMESTICO,
  FETCHED_DOMESTICO,
  SUBMITED_DOMESTICO,
  SUBMIT_DOMESTICO_ERROR,
  RESET_DOMESTICO_SUBMIT,
  CLEAR_ALERT_DIALOG,
  RESET_DOMESTICO_PROCESSING,
  STARTED_DOMESTICO_PROCESSING,
} from './mutations.type';
// eslint-disable-next-line import/no-cycle
import ApiService from '../common/api.service';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
  alertDialog: false,
  alertDialogMessage: '',
  alertDialogType: 'success',
  loading_domesticos: false,
  submited_domestico: false,
  processing_domestico: false,
  loading_domestico: false,
};

const getters = {
  is_loading() {
    return state.loading_domesticos;
  },
  colaborador_submited() {
    return state.submited_domestico;
  },
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
  alertDialog(state) {
    return state.alertDialog;
  },
  alertDialogMessage(state) {
    return state.alertDialogMessage;
  },
  alertDialogType(state) {
    return state.alertDialogType;
  },
  domestico_processing() {
    return state.processing_domestico;
  },
};

const actions = {
  [FETCH_DOMESTICO_INFO](context, domesticoId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_DOMESTICO);
      const url = `domesticos/${domesticoId}`;
      ApiService.query(url)
        .then(({ data }) => {
          context.commit(FETCHED_DOMESTICO);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_DOMESTICO);
        });
    });
  },
  [SEND_DOMESTICO](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.upload('domesticos', data)
        .then(({ data }) => {
          context.commit(SUBMITED_DOMESTICO, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_DOMESTICO_ERROR, [response.data.message]);
        });
    });
  },
  [EDIT_DOMESTICO](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.upload(`domesticos/${data.get("domestico_id")}`, data)
        .then(({ data }) => {
          context.commit(SUBMITED_DOMESTICO, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_DOMESTICO_ERROR, [response.data.message]);
        });
    });
  },
};

const mutations = {
  [FETCHING_DOMESTICO](state) {
    state.loading_domestico = true;
  },
  [FETCHED_DOMESTICO](state) {
    state.loading_domestico = false;
  },
  [SUBMITED_DOMESTICO](state, data) {
    state.submited_domestico = true;
    state.alert = true;
    if (data.code !== 0) {
      state.alertType = 'error';
      state.alertMessage = data.message;
    } else {
      state.alertType = 'success';
      state.alertMessage = data.message;
    }
  },
  [SUBMIT_DOMESTICO_ERROR](state, data) {
    state.processing_domestico = false;
    state.alertDialog = true;
    state.alertDialogType = 'error';
    state.alertDialogMessage = data;
  },
  [RESET_DOMESTICO_SUBMIT](state) {
    state.submited_domestico = false;
    state.alert = false;
    state.alertMessage = 'default';
    state.alertType = 'warning';
  },
  [CLEAR_ALERT_DIALOG](state) {
    state.alertDialog = false;
    state.alertDialogMessage = '';
    state.alertDialogType = 'success';
  },
  [RESET_DOMESTICO_PROCESSING](state) {
    state.processing_domestico = false;
  },
  [STARTED_DOMESTICO_PROCESSING](state) {
    state.processing_domestico = true;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
